export const translations = {
  en: {
    translation: {
      'Failed to load the payment form.': 'Failed to load the payment form.',
      'Oops... something went wrong': 'Oops... something went wrong',
      'Please refresh the page to try again.':
        'Please refresh the page to try again.',
      'First name': 'First name',
      'Last name': 'Last name',
      Address: 'Address',
      City: 'City',
      'Zip code': 'Zip code',
      'Country or region': 'Country or region',
      Optional: 'Optional',
      Company: 'Company',
      'Payment method': 'Payment method',
      Subtotal: 'Subtotal',
      Taxes: 'Taxes',
      Remove: 'Remove',
      Quantity: 'Quantity',
      'Continue shopping': 'Continue shopping',
      'Please enter a valid email address.':
        'Please enter a valid email address.',
      'Please enter a valid promo code.': 'Please enter a valid promo code.',
      'Billing information': 'Billing information',
      '14-day money back guarantee.': '14-day money back guarantee.',
      'Please select': 'Please select',
      'VAT ID': 'VAT ID',
      'Payment Details': 'Payment Details',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'All Chaos products are intended for professional use only and not for consumer use.',
      'Loading your cart…': 'Loading your cart…',
      'Proof of student status': 'Proof of student status',
      'Expected graduation date': 'Expected graduation date',
      'Choose date': 'Choose date',
      'Name of academic institution': 'Name of academic institution',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': 'City of academic institution',
      Oxford: 'Oxford',
      'Country of academic institution': 'Country of academic institution',
      'Proof of student status document (jpg, png, pdf)':
        'Proof of student status document (jpg, png, pdf)',
      'Choose file': 'Choose file',
      'How we review your documents': 'How we review your documents',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our',
      '<policy>Privacy Policy</policy>.': '<policy>Privacy Policy</policy>.',
      'Additional information (optional)': 'Additional information (optional)',
      'What is considered valid evidence of current enrollment?':
        'What is considered valid evidence of current enrollment?',
      'A valid, dated student ID which includes your name and photo':
        'A valid, dated student ID which includes your name and photo',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.',
      'You can find <eligibility>more details here.</eligibility>':
        'You can find <eligibility>more details here.</eligibility>',
      'Your proof is under review.': 'Your proof is under review.',
      'Your proof is approved.': 'Your proof is approved.',
      'Field cannot be empty.': 'Field cannot be empty.',
      'File cannot be empty.': 'File cannot be empty.',
      'Please upload only jpeg, png or pdf file.':
        'Please upload only jpeg, png or pdf file.',
      'File cannot be larger than 4 megabytes.':
        'File cannot be larger than 4 megabytes.',
      'Failed to submit proof of status.': 'Failed to submit proof of status.',
      'Your educational status has not been confirmed.':
        'Your educational status has not been confirmed.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.',
      'You already have an active EDU subscription for this product.':
        'You already have an active EDU subscription for this product.',
      'Thank you for your order': 'Thank you for your order',
      'Go create something awesome!': 'Go create something awesome!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        'Your products are ready for download. We will send you an email with all the necessary instructions.',
      Download: 'Download',
      'Go to admin dashboard': 'Go to admin dashboard',
      Mail: 'Mail',
      Contact: 'Contact',
      email: 'email',
      'Continue with payment details': 'Continue with payment details',
      'switch user': 'switch user',
      edit: 'edit',
      'Order summary': 'Order summary',
      'Always included': 'Always included',
      'You already have an active or expired license.':
        'You already have an active or expired license.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.',
      'Referral limit exceeded.': 'Referral limit exceeded.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!',
      'Start free trial': 'Start free trial',
      '{{name}} {{days}}-day free trial ends':
        '{{name}} {{days}}-day free trial ends',
      'Due {{date}}': 'Due {{date}}',
      '+ taxes': '+ taxes',
      'Pay Now': 'Pay Now',
      'Free trial terms': 'Free trial terms',
      'Billing starts automatically after the free trial ends.':
        'Billing starts automatically after the free trial ends.',
      'Cancel before {{date}} to avoid getting billed.':
        'Cancel before {{date}} to avoid getting billed.',
      'Your free trial version is ready': 'Your free trial version is ready',
      'Millions of users trust our products':
        'Millions of users trust our products',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} based on {{reviews}} reviews',
      'Free learning resources, support & community access':
        'Free learning resources, support & community access',
      'Limited time introductory prices': 'Limited time introductory prices',
      'Purchase Limit Reached': 'Purchase Limit Reached',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.',
      'Please contact our Sales team to proceed with your order.':
        'Please contact our Sales team to proceed with your order.',
      Close: 'Close',
      'Credit/Debit card': 'Credit/Debit card',
      'Pay {{currencySymbol}}{{amount}}': 'Pay {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': 'Checkout with PayPal',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, billed {{cadence}}',
      'Product Overview': 'Product Overview',
      'Your cart is empty': 'Your cart is empty',
      'Get your products now and start creating something awesome.':
        'Get your products now and start creating something awesome.',
      'Explore our products': 'Explore our products',
      'Upgrade for only € 5': 'Upgrade for only € 5',
      'Upgrade now': 'Upgrade now',
      Includes: 'Includes',
      'Your selection': 'Your selection',
      'Continue with checkout': 'Continue with checkout',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}',
      Total: 'Total',
      'Increase quantity': 'Increase quantity',
      'Decrease quantity': 'Decrease quantity',
      'Go to pricing': 'Go to pricing',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.',
      'Managed users are not allowed to buy products.':
        'Managed users are not allowed to buy products.',
      'Your account is cancelled.': 'Your account is cancelled.',
      'Please contact the Chaos License Compliance Team for assistance.':
        'Please contact the Chaos License Compliance Team for assistance.',
      'PayPal init failed.': 'PayPal init failed.',
      'PayPal payment failed.': 'PayPal payment failed.',
      'Placing order failed.': 'Placing order failed.',
      'Payment failed.': 'Payment failed.',
      'Promo code': 'Promo code',
      'Remove promo code': 'Remove promo code',
      Apply: 'Apply',
      'Promo code applied.': 'Promo code applied.',
      'We accept': 'We accept',
      'Amnesty discount applied.': 'Amnesty discount applied.',
      'Code not valid or already used.': 'Code not valid or already used.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        'Contact us at licensecompliance@chaos.com to resolve your case.',
      'Promo Applied.': 'Promo Applied.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} license - billed {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} licenses - billed {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} licenses - billed {{cadence}}',
      monthly: 'monthly',
      annually: 'annually',
      'every 3 years': 'every 3 years',
      named: 'named',
      floating: 'floating',
    },
  },
  jp: {
    translation: {
      'Failed to load the payment form.':
        '支払いフォームの読み込みに失敗しました。',
      'Oops... something went wrong': 'おっと、問題が発生しました',
      'Please refresh the page to try again.':
        'ページを更新してもう一度お試しください。',
      'First name': '名',
      'Last name': '姓',
      Address: '住所',
      City: '市区町村',
      'Zip code': '郵便番号',
      'Country or region': '国または地域',
      Optional: '任意',
      Company: '会社名',
      'Payment method': '支払方法',
      Subtotal: '小計',
      Taxes: '税',
      Remove: '削除',
      Quantity: '数量',
      'Continue shopping': 'ショッピングを続ける',
      'Please enter a valid email address.':
        '有効なメールアドレスを入力してください。',
      'Please enter a valid promo code.':
        '有効なプロモーションコードを入力してください。',
      'Billing information': 'ご請求情報',
      '14-day money back guarantee.': '14 日間の返金保証。',
      'Please select': '選択してください',
      'VAT ID': 'VAT ID',
      'Payment Details': 'お支払いの詳細',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        '本製品を購入することで、<privacy>データプライバシー</privacy>、<terms>利用規約</terms>、および<eula>EULA</eula>に同意したものとみなされます。',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Chaos製品はすべて、消費者向けではなく、専門的な用途のみを目的としています。',
      'Loading your cart…': 'カートを読み込んでいます…',
      'Proof of student status': '在学証明',
      'Expected graduation date': '卒業予定日',
      'Choose date': '日付を選択',
      'Name of academic institution': '教育機関名',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': '教育機関の所在地（市区町村）',
      Oxford: 'Oxford',
      'Country of academic institution': '教育機関の所在国',
      'Proof of student status document (jpg, png, pdf)':
        '在学証明書類（jpg、png、pdf）',
      'Choose file': 'ファイルを選択',
      'How we review your documents': '書類の審査方法について',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        '学生割引のために提出された書類の審査を支援するため、当社は書類の有効性について参考となる評価を提供する人工知能（AI）システムを使用しています。最終的な判断は常に審査担当者が行います。ご質問がある場合、またはデータ保護に関する権利を行使される場合は、当社の',
      '<policy>Privacy Policy</policy>.':
        '<policy>プライバシーポリシー</policy>をご確認ください。',
      'Additional information (optional)': '追加情報（任意）',
      'What is considered valid evidence of current enrollment?':
        '在学中であることの有効な証明として認められるものは何ですか？',
      'A valid, dated student ID which includes your name and photo':
        '氏名と写真が記載された、有効で日付のある学生証',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        '在籍状況、氏名、教育機関、在籍期間が記載された学術書類。例としては、成績証明書、授業料請求書、現在の成績表または成績報告書、日付のある現在の時間割などがあります。',
      'You can find <eligibility>more details here.</eligibility>':
        '詳細は<eligibility>こちらでご確認いただけます。</eligibility>',
      'Your proof is under review.':
        'ご提出いただいた証明書類は現在審査中です。',
      'Your proof is approved.': 'ご提出いただいた証明書類は承認されました。',
      'Field cannot be empty.': 'この項目は入力必須です。',
      'File cannot be empty.': 'ファイルを選択してください。',
      'Please upload only jpeg, png or pdf file.':
        'jpeg、png、pdf のいずれかのファイルのみをアップロードしてください。',
      'File cannot be larger than 4 megabytes.':
        'ファイルサイズは 4 メガバイトを超えることはできません。',
      'Failed to submit proof of status.': '在学証明の提出に失敗しました。',
      'Your educational status has not been confirmed.':
        '教育機関在籍の認定が確認できませんでした。',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        '再度お申し込みのうえ教育割引をご利用になりたい場合は、education@chaos.com までメールでご連絡ください。',
      'You already have an active EDU subscription for this product.':
        'この製品について、すでに有効な EDU サブスクリプションをお持ちです。',
      'Thank you for your order': 'ご注文ありがとうございます',
      'Go create something awesome!': 'さあ、素晴らしい作品を作りましょう！',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        '製品のダウンロードの準備が整いました。必要な手順をすべて記載したメールをお送りします。',
      Download: 'ダウンロード',
      'Go to admin dashboard': '管理ダッシュボードへ移動',
      Mail: 'メール',
      Contact: 'お問い合わせ',
      email: 'メールアドレス',
      'Continue with payment details': 'お支払いの詳細に進む',
      'switch user': 'ユーザーを切り替える',
      edit: '編集',
      'Order summary': '注文内容',
      'Always included': '常に含まれるもの',
      'You already have an active or expired license.':
        'すでに有効または期限切れのライセンスをお持ちです。',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'この製品について、すでに有効または期限切れのライセンスをお持ちです。アカウントからサブスクリプションを<link>管理またはアップグレード</link>してください。',
      'Referral limit exceeded.': '紹介の上限を超えました。',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        '紹介プログラムでは最大 3 ライセンスまで購入できます。カート内のライセンス数を減らして、デザインを始めましょう！',
      'Start free trial': '無料トライアルを開始',
      '{{name}} {{days}}-day free trial ends':
        '{{name}} の {{days}} 日間の無料トライアルが終了します',
      'Due {{date}}': '期限：{{date}}',
      '+ taxes': '＋税',
      'Pay Now': '今すぐ支払う',
      'Free trial terms': '無料トライアルの規約',
      'Billing starts automatically after the free trial ends.':
        '無料トライアル終了後、自動的に請求が開始されます。',
      'Cancel before {{date}} to avoid getting billed.':
        '請求を避けるには、{{date}} までにキャンセルしてください。',
      'Your free trial version is ready': '無料トライアル版の準備が整いました',
      'Millions of users trust our products':
        '数百万人のユーザーが当社の製品を信頼しています',
      '{{rating}} based on {{reviews}} reviews':
        '{{reviews}} 件のレビューに基づく {{rating}}',
      'Free learning resources, support & community access':
        '無料の学習リソース、サポート、コミュニティへのアクセス',
      'Limited time introductory prices': '期間限定の特別導入価格',
      'Purchase Limit Reached': '購入上限に達しました',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        '{{currencySymbol}}{{limit}} を超えるご購入は、オンラインでは完了できません。',
      'Please contact our Sales team to proceed with your order.':
        'ご注文を進めるには、当社の営業チームにお問い合わせください。',
      Close: '閉じる',
      'Credit/Debit card': 'クレジット/デビットカード',
      'Pay {{currencySymbol}}{{amount}}':
        '{{currencySymbol}}{{amount}} を支払う',
      'Checkout with PayPal': 'PayPal で支払う',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}、請求：{{cadence}}',
      'Product Overview': '製品概要',
      'Your cart is empty': 'カートは空です',
      'Get your products now and start creating something awesome.':
        '今すぐ製品を入手して、素晴らしい作品を作り始めましょう。',
      'Explore our products': '製品を見る',
      'Upgrade for only € 5': 'わずか € 5 でアップグレード',
      'Upgrade now': '今すぐアップグレード',
      Includes: '含まれるもの',
      'Your selection': '選択した内容',
      'Continue with checkout': '購入手続きに進む',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        '数量：{{quantity}} | {{licenseType}}、請求：{{cadence}}',
      Total: '合計',
      'Increase quantity': '数量を増やす',
      'Decrease quantity': '数量を減らす',
      'Go to pricing': '料金ページへ移動',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'このご注文は現在処理できません。サポートが必要な場合は、Chaos License Compliance Team までお問い合わせください。',
      'Managed users are not allowed to buy products.':
        '管理対象ユーザーは製品を購入できません。',
      'Your account is cancelled.': 'お客様のアカウントは解約されています。',
      'Please contact the Chaos License Compliance Team for assistance.':
        'サポートが必要な場合は、Chaos License Compliance Team までお問い合わせください。',
      'PayPal init failed.': 'PayPal の初期化に失敗しました。',
      'PayPal payment failed.': 'PayPal での支払いに失敗しました。',
      'Placing order failed.': '注文の確定に失敗しました。',
      'Payment failed.': '支払いに失敗しました。',
      'Promo code': 'プロモーションコード',
      'Remove promo code': 'プロモーションコードを削除',
      Apply: '適用',
      'Promo code applied.': 'プロモーションコードが適用されました。',
      'We accept': 'ご利用いただけるお支払い方法',
      'Amnesty discount applied.': 'アムネスティ割引が適用されました。',
      'Code not valid or already used.':
        'コードが無効か、すでに使用されています。',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        '案件を解決するには、licensecompliance@chaos.com までお問い合わせください。',
      'Promo Applied.': 'プロモーションが適用されました。',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        'この注文の対象製品それぞれに、3,000 の無料 Chaos Credits が含まれています！合計クレジットは、チェックアウト完了時にアカウントへ付与されます。',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        'このご注文には 500 の無料 Chaos Credits が含まれています！クレジットは、チェックアウト完了時に 1 回付与されます。',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} ライセンス - 請求：{{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} ライセンス - 請求：{{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} ライセンス - 請求：{{cadence}}',
      monthly: '毎月',
      annually: '毎年',
      'every 3 years': '3年ごと',
      named: '指名',
      floating: 'フローティング',
    },
  },
  es: {
    translation: {
      'Failed to load the payment form.':
        'No se pudo cargar el formulario de pago.',
      'Oops... something went wrong': 'Vaya... algo salió mal',
      'Please refresh the page to try again.':
        'Actualiza la página para volver a intentarlo.',
      'First name': 'Nombre',
      'Last name': 'Apellidos',
      Address: 'Dirección',
      City: 'Ciudad',
      'Zip code': 'Código postal',
      'Country or region': 'País o Región',
      Optional: 'Opcional',
      Company: 'Empresa',
      'Payment method': 'Método de pago',
      Subtotal: 'Subtotal',
      Taxes: 'Impuestos',
      Remove: 'Eliminar',
      Quantity: 'Cantidad',
      'Continue shopping': 'Continuar comprando',
      'Please enter a valid email address.':
        'Introduce una dirección de correo electrónico válida.',
      'Please enter a valid promo code.':
        'Introduce un código promocional válido.',
      'Billing information': 'Información de facturación',
      '14-day money back guarantee.':
        'Garantía de devolución de dinero en 14 días.',
      'Please select': 'Selecciona una opción',
      'VAT ID': 'Número de IVA',
      'Payment Details': 'Detalles del pago',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        'Al comprar este producto, confirmas que aceptas la <privacy>privacidad de datos</privacy>, los <terms>términos y condiciones</terms> y el <eula>EULA</eula>.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Todos los productos de Chaos están destinados únicamente a uso profesional y no a uso por parte de consumidores.',
      'Loading your cart…': 'Cargando tu carrito…',
      'Proof of student status': 'Comprobante de condición de estudiante',
      'Expected graduation date': 'Fecha prevista de graduación',
      'Choose date': 'Elegir fecha',
      'Name of academic institution': 'Nombre de la institución académica',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': 'Ciudad de la institución académica',
      Oxford: 'Oxford',
      'Country of academic institution': 'País de la institución académica',
      'Proof of student status document (jpg, png, pdf)':
        'Documento de comprobante de condición de estudiante (jpg, png, pdf)',
      'Choose file': 'Elegir archivo',
      'How we review your documents': 'Cómo revisamos tus documentos',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        'Para ayudar a revisar los documentos enviados para los descuentos de estudiante, utilizamos un sistema de inteligencia artificial (IA) que ayuda a nuestro equipo proporcionando una evaluación indicativa de la aparente validez de un documento. Las decisiones finales siempre las toma un revisor humano. Puedes ponerte en contacto con nosotros si tienes preguntas o para ejercer tus derechos de protección de datos consultando nuestra',
      '<policy>Privacy Policy</policy>.':
        '<policy>Política de privacidad</policy>.',
      'Additional information (optional)': 'Información adicional (opcional)',
      'What is considered valid evidence of current enrollment?':
        '¿Qué se considera una prueba válida de matrícula actual?',
      'A valid, dated student ID which includes your name and photo':
        'Un carné de estudiante válido y fechado que incluya tu nombre y foto',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        'Un documento académico que indique tu situación de matrícula, tu nombre, la institución educativa y las fechas de matrícula. Algunos ejemplos son un expediente académico, una factura de matrícula, un boletín de notas o informe de progreso actual, un horario de clases actual con fecha, etc.',
      'You can find <eligibility>more details here.</eligibility>':
        'Puedes encontrar <eligibility>más detalles aquí.</eligibility>',
      'Your proof is under review.': 'Tu comprobante está en revisión.',
      'Your proof is approved.': 'Tu comprobante ha sido aprobado.',
      'Field cannot be empty.': 'El campo no puede estar vacío.',
      'File cannot be empty.': 'El archivo no puede estar vacío.',
      'Please upload only jpeg, png or pdf file.':
        'Sube únicamente archivos jpeg, png o pdf.',
      'File cannot be larger than 4 megabytes.':
        'El archivo no puede superar los 4 megabytes.',
      'Failed to submit proof of status.':
        'No se pudo enviar el comprobante de condición.',
      'Your educational status has not been confirmed.':
        'No se ha confirmado tu condición educativa.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        'Si deseas volver a solicitarlo y desbloquear el descuento educativo, escríbenos a education@chaos.com.',
      'You already have an active EDU subscription for this product.':
        'Ya tienes una suscripción EDU activa para este producto.',
      'Thank you for your order': 'Gracias por tu pedido',
      'Go create something awesome!': '¡Ve y crea algo increíble!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        'Tus productos están listos para descargar. Te enviaremos un correo electrónico con todas las instrucciones necesarias.',
      Download: 'Descargar',
      'Go to admin dashboard': 'Ir al panel de administración',
      Mail: 'Correo',
      Contact: 'Contacto',
      email: 'correo electrónico',
      'Continue with payment details': 'Continuar con los detalles del pago',
      'switch user': 'cambiar de usuario',
      edit: 'editar',
      'Order summary': 'Resumen del pedido',
      'Always included': 'Siempre incluido',
      'You already have an active or expired license.':
        'Ya tienes una licencia activa o caducada.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'Ya tienes una licencia activa o caducada para este producto. <link>Gestiona o mejora</link> tu suscripción desde tu cuenta.',
      'Referral limit exceeded.': 'Se ha superado el límite de referidos.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'Puedes comprar hasta 3 licencias a través del programa de referidos. Reduce la cantidad de licencias en tu carrito y ¡empieza a diseñar!',
      'Start free trial': 'Iniciar prueba gratuita',
      '{{name}} {{days}}-day free trial ends':
        'La prueba gratuita de {{days}} días de {{name}} finaliza',
      'Due {{date}}': 'Vence el {{date}}',
      '+ taxes': '+ impuestos',
      'Pay Now': 'Pagar ahora',
      'Free trial terms': 'Condiciones de la prueba gratuita',
      'Billing starts automatically after the free trial ends.':
        'La facturación comienza automáticamente cuando finaliza la prueba gratuita.',
      'Cancel before {{date}} to avoid getting billed.':
        'Cancela antes del {{date}} para evitar que se te cobre.',
      'Your free trial version is ready':
        'Tu versión de prueba gratuita está lista',
      'Millions of users trust our products':
        'Millones de usuarios confían en nuestros productos',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} según {{reviews}} reseñas',
      'Free learning resources, support & community access':
        'Recursos de aprendizaje gratuitos, soporte y acceso a la comunidad',
      'Limited time introductory prices':
        'Precios de lanzamiento por tiempo limitado',
      'Purchase Limit Reached': 'Límite de compra alcanzado',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Las compras superiores a {{currencySymbol}}{{limit}} no se pueden completar en línea.',
      'Please contact our Sales team to proceed with your order.':
        'Ponte en contacto con nuestro equipo de ventas para continuar con tu pedido.',
      Close: 'Cerrar',
      'Credit/Debit card': 'Tarjeta de crédito/débito',
      'Pay {{currencySymbol}}{{amount}}': 'Pagar {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': 'Pagar con PayPal',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, facturación {{cadence}}',
      'Product Overview': 'Descripción del producto',
      'Your cart is empty': 'Tu carrito está vacío',
      'Get your products now and start creating something awesome.':
        'Consigue tus productos ahora y empieza a crear algo increíble.',
      'Explore our products': 'Explora nuestros productos',
      'Upgrade for only € 5': 'Mejora por solo € 5',
      'Upgrade now': 'Mejorar ahora',
      Includes: 'Incluye',
      'Your selection': 'Tu selección',
      'Continue with checkout': 'Continuar con el pago',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Cantidad: {{quantity}} | {{licenseType}}, facturación {{cadence}}',
      Total: 'Total',
      'Increase quantity': 'Aumentar cantidad',
      'Decrease quantity': 'Disminuir cantidad',
      'Go to pricing': 'Ir a precios',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'Este pedido no se puede procesar en este momento. Para obtener ayuda, ponte en contacto con el Chaos License Compliance Team.',
      'Managed users are not allowed to buy products.':
        'Los usuarios gestionados no pueden comprar productos.',
      'Your account is cancelled.': 'Tu cuenta está cancelada.',
      'Please contact the Chaos License Compliance Team for assistance.':
        'Para obtener ayuda, ponte en contacto con el Chaos License Compliance Team.',
      'PayPal init failed.': 'No se pudo inicializar PayPal.',
      'PayPal payment failed.': 'El pago con PayPal falló.',
      'Placing order failed.': 'No se pudo realizar el pedido.',
      'Payment failed.': 'El pago falló.',
      'Promo code': 'Código promocional',
      'Remove promo code': 'Eliminar código promocional',
      Apply: 'Aplicar',
      'Promo code applied.': 'Código promocional aplicado.',
      'We accept': 'Aceptamos',
      'Amnesty discount applied.': 'Descuento de amnistía aplicado.',
      'Code not valid or already used.':
        'El código no es válido o ya se ha utilizado.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        'Ponte en contacto con nosotros en licensecompliance@chaos.com para resolver tu caso.',
      'Promo Applied.': 'Promoción aplicada.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '¡Se incluyen 3.000 Chaos Credits gratuitos con cada producto apto de este pedido! El total de tus créditos se asignará a tu cuenta al completar la compra.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        '¡Este pedido incluye 500 Chaos Credits gratuitos! Los créditos se asignarán una sola vez al completar la compra.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} licencia - facturación {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} licencias - facturación {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} licencias - facturación {{cadence}}',
      monthly: 'mensual',
      annually: 'anual',
      'every 3 years': 'cada 3 años',
      named: 'nominativa',
      floating: 'flotante',
    },
  },
  pt: {
    translation: {
      'Failed to load the payment form.':
        'Falha ao carregar o formulário de pagamento.',
      'Oops... something went wrong': 'Ops... algo deu errado',
      'Please refresh the page to try again.':
        'Atualize a página para tentar novamente.',
      'First name': 'Nome',
      'Last name': 'Sobrenome',
      Address: 'Endereço',
      City: 'Cidade',
      'Zip code': 'CEP',
      'Country or region': 'País ou Região',
      Optional: 'Opcional',
      Company: 'Empresa',
      'Payment method': 'Método de pagamento',
      Subtotal: 'Subtotal',
      Taxes: 'Impostos',
      Remove: 'Remover',
      Quantity: 'Quantidade',
      'Continue shopping': 'Continuar comprando',
      'Please enter a valid email address.':
        'Insira um endereço de e-mail válido.',
      'Please enter a valid promo code.':
        'Insira um código promocional válido.',
      'Billing information': 'Informações de cobrança',
      '14-day money back guarantee.':
        'Prazo de 14 dias para pedido de reembolso.',
      'Please select': 'Selecione',
      'VAT ID': 'Número de IVA',
      'Payment Details': 'Detalhes do pagamento',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        'Ao comprar este produto, você confirma que aceita a <privacy>privacidade de dados</privacy>, os <terms>termos e condições</terms> e o <eula>EULA</eula>.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Todos os produtos da Chaos destinam-se apenas a uso profissional e não ao uso por consumidores.',
      'Loading your cart…': 'Carregando seu carrinho…',
      'Proof of student status': 'Comprovante de matrícula',
      'Expected graduation date': 'Data prevista de formatura',
      'Choose date': 'Escolher data',
      'Name of academic institution': 'Nome da instituição de ensino',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': 'Cidade da instituição de ensino',
      Oxford: 'Oxford',
      'Country of academic institution': 'País da instituição de ensino',
      'Proof of student status document (jpg, png, pdf)':
        'Documento de comprovante de matrícula (jpg, png, pdf)',
      'Choose file': 'Escolher arquivo',
      'How we review your documents': 'Como analisamos seus documentos',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        'Para ajudar a analisar os documentos enviados para descontos de estudante, utilizamos um sistema de inteligência artificial (IA) que auxilia nossa equipe fornecendo uma avaliação indicativa da aparente validade de um documento. As decisões finais são sempre tomadas por um revisor humano. Você pode entrar em contato conosco com dúvidas ou para exercer seus direitos de proteção de dados consultando nossa',
      '<policy>Privacy Policy</policy>.':
        '<policy>Política de Privacidade</policy>.',
      'Additional information (optional)': 'Informações adicionais (opcional)',
      'What is considered valid evidence of current enrollment?':
        'O que é considerado comprovante válido de matrícula atual?',
      'A valid, dated student ID which includes your name and photo':
        'Uma carteira de estudante válida e datada que inclua seu nome e foto',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        'Um documento acadêmico que indique sua situação de matrícula, seu nome, a instituição de ensino e as datas de matrícula. Exemplos incluem um histórico escolar, boleto de mensalidade, boletim de notas ou relatório de progresso atual, grade de horários atual com data, etc.',
      'You can find <eligibility>more details here.</eligibility>':
        'Você pode encontrar <eligibility>mais detalhes aqui.</eligibility>',
      'Your proof is under review.': 'Seu comprovante está em análise.',
      'Your proof is approved.': 'Seu comprovante foi aprovado.',
      'Field cannot be empty.': 'O campo não pode ficar vazio.',
      'File cannot be empty.': 'O arquivo não pode ficar vazio.',
      'Please upload only jpeg, png or pdf file.':
        'Envie apenas arquivos jpeg, png ou pdf.',
      'File cannot be larger than 4 megabytes.':
        'O arquivo não pode ter mais de 4 megabytes.',
      'Failed to submit proof of status.':
        'Falha ao enviar o comprovante de status.',
      'Your educational status has not been confirmed.':
        'Seu status educacional não foi confirmado.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        'Se você quiser se inscrever novamente e desbloquear o desconto educacional, envie um e-mail para education@chaos.com.',
      'You already have an active EDU subscription for this product.':
        'Você já tem uma assinatura EDU ativa para este produto.',
      'Thank you for your order': 'Obrigado pelo seu pedido',
      'Go create something awesome!': 'Vá criar algo incrível!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        'Seus produtos estão prontos para download. Enviaremos um e-mail com todas as instruções necessárias.',
      Download: 'Baixar',
      'Go to admin dashboard': 'Ir para o painel de administração',
      Mail: 'E-mail',
      Contact: 'Contato',
      email: 'e-mail',
      'Continue with payment details': 'Continuar com os detalhes do pagamento',
      'switch user': 'trocar de usuário',
      edit: 'editar',
      'Order summary': 'Resumo do pedido',
      'Always included': 'Sempre incluído',
      'You already have an active or expired license.':
        'Você já tem uma licença ativa ou expirada.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'Você já tem uma licença ativa ou expirada para este produto. <link>Gerencie ou faça upgrade</link> da sua assinatura na sua conta.',
      'Referral limit exceeded.': 'Limite de indicações excedido.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'Você pode comprar até 3 licenças por meio do programa de indicações. Reduza a quantidade de licenças no seu carrinho e comece a criar!',
      'Start free trial': 'Iniciar avaliação gratuita',
      '{{name}} {{days}}-day free trial ends':
        'A avaliação gratuita de {{days}} dias do {{name}} termina',
      'Due {{date}}': 'Vence em {{date}}',
      '+ taxes': '+ impostos',
      'Pay Now': 'Pagar agora',
      'Free trial terms': 'Termos da avaliação gratuita',
      'Billing starts automatically after the free trial ends.':
        'A cobrança começa automaticamente após o término da avaliação gratuita.',
      'Cancel before {{date}} to avoid getting billed.':
        'Cancele antes de {{date}} para evitar a cobrança.',
      'Your free trial version is ready':
        'Sua versão de avaliação gratuita está pronta',
      'Millions of users trust our products':
        'Milhões de usuários confiam em nossos produtos',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} com base em {{reviews}} avaliações',
      'Free learning resources, support & community access':
        'Recursos de aprendizado gratuitos, suporte e acesso à comunidade',
      'Limited time introductory prices':
        'Preços de lançamento por tempo limitado',
      'Purchase Limit Reached': 'Limite de compra atingido',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Compras acima de {{currencySymbol}}{{limit}} não podem ser concluídas on-line.',
      'Please contact our Sales team to proceed with your order.':
        'Entre em contato com nossa equipe de vendas para prosseguir com seu pedido.',
      Close: 'Fechar',
      'Credit/Debit card': 'Cartão de crédito/débito',
      'Pay {{currencySymbol}}{{amount}}': 'Pagar {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': 'Finalizar com o PayPal',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, cobrança {{cadence}}',
      'Product Overview': 'Visão geral do produto',
      'Your cart is empty': 'Seu carrinho está vazio',
      'Get your products now and start creating something awesome.':
        'Adquira seus produtos agora e comece a criar algo incrível.',
      'Explore our products': 'Explore nossos produtos',
      'Upgrade for only € 5': 'Faça upgrade por apenas € 5',
      'Upgrade now': 'Fazer upgrade agora',
      Includes: 'Inclui',
      'Your selection': 'Sua seleção',
      'Continue with checkout': 'Continuar para o pagamento',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Quantidade: {{quantity}} | {{licenseType}}, cobrança {{cadence}}',
      Total: 'Total',
      'Increase quantity': 'Aumentar quantidade',
      'Decrease quantity': 'Diminuir quantidade',
      'Go to pricing': 'Ir para preços',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'Este pedido não pode ser processado no momento. Para obter ajuda, entre em contato com o Chaos License Compliance Team.',
      'Managed users are not allowed to buy products.':
        'Os usuários gerenciados não podem comprar produtos.',
      'Your account is cancelled.': 'Sua conta está cancelada.',
      'Please contact the Chaos License Compliance Team for assistance.':
        'Para obter ajuda, entre em contato com o Chaos License Compliance Team.',
      'PayPal init failed.': 'Falha ao inicializar o PayPal.',
      'PayPal payment failed.': 'Falha no pagamento com o PayPal.',
      'Placing order failed.': 'Falha ao realizar o pedido.',
      'Payment failed.': 'Falha no pagamento.',
      'Promo code': 'Código promocional',
      'Remove promo code': 'Remover código promocional',
      Apply: 'Aplicar',
      'Promo code applied.': 'Código promocional aplicado.',
      'We accept': 'Aceitamos',
      'Amnesty discount applied.': 'Desconto de anistia aplicado.',
      'Code not valid or already used.': 'Código inválido ou já utilizado.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        'Entre em contato conosco em licensecompliance@chaos.com para resolver seu caso.',
      'Promo Applied.': 'Promoção aplicada.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '3.000 Chaos Credits gratuitos estão incluídos em cada produto qualificado deste pedido! O total de créditos será provisionado na sua conta após a conclusão da compra.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        '500 Chaos Credits gratuitos estão incluídos neste pedido! Os créditos serão provisionados uma única vez após a conclusão da compra.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} licença - cobrança {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} licenças - cobrança {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} licenças - cobrança {{cadence}}',
      monthly: 'mensal',
      annually: 'anual',
      'every 3 years': 'a cada 3 anos',
      named: 'nomeada',
      floating: 'flutuante',
    },
  },
  cn: {
    translation: {
      'Failed to load the payment form.': '无法加载支付表单。',
      'Oops... something went wrong': '糟糕……出了点问题',
      'Please refresh the page to try again.': '请刷新页面后重试。',
      'First name': '名字',
      'Last name': '姓氏',
      Address: '地址',
      City: '城市',
      'Zip code': '邮编',
      'Country or region': '国家或地区',
      Optional: '可选',
      Company: '公司',
      'Payment method': '支付方式',
      Subtotal: '小计',
      Taxes: '税费',
      Remove: '移除',
      Quantity: '数量',
      'Continue shopping': '继续购买',
      'Please enter a valid email address.': '请输入有效的电子邮件地址。',
      'Please enter a valid promo code.': '请输入有效的促销代码。',
      'Billing information': '账单信息',
      '14-day money back guarantee.': '14 天退款保证。',
      'Please select': '请选择',
      'VAT ID': 'VAT ID',
      'Payment Details': '支付详情',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        '购买本产品即表示您确认接受<privacy>数据隐私</privacy>、<terms>条款和条件</terms>以及<eula>EULA</eula>。',
      'All Chaos products are intended for professional use only and not for consumer use.':
        '所有 Chaos 产品仅供专业用途，不适用于消费者使用。',
      'Loading your cart…': '正在加载您的购物车…',
      'Proof of student status': '学生身份证明',
      'Expected graduation date': '预计毕业日期',
      'Choose date': '选择日期',
      'Name of academic institution': '院校名称',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': '院校所在城市',
      Oxford: 'Oxford',
      'Country of academic institution': '院校所在国家',
      'Proof of student status document (jpg, png, pdf)':
        '学生身份证明文件（jpg、png、pdf）',
      'Choose file': '选择文件',
      'How we review your documents': '我们如何审核您的文件',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        '为帮助审核为申请学生折扣而提交的文件，我们使用人工智能（AI）系统协助团队对文件的表面有效性提供初步评估。最终决定始终由人工审核员作出。如有疑问或需行使您的数据保护权利，请查阅我们的',
      '<policy>Privacy Policy</policy>.': '<policy>隐私政策</policy>。',
      'Additional information (optional)': '附加信息（可选）',
      'What is considered valid evidence of current enrollment?':
        '哪些材料可作为当前在读的有效证明？',
      'A valid, dated student ID which includes your name and photo':
        '一张有效且注明日期、包含您姓名和照片的学生证',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        '一份注明您的在读状态、姓名、教育机构及就读起止日期的学术文件。例如成绩单、学费账单、当前的学生成绩单或学业进度报告、注明日期的当前课程表等。',
      'You can find <eligibility>more details here.</eligibility>':
        '您可以在<eligibility>此处查看更多详情。</eligibility>',
      'Your proof is under review.': '您的证明正在审核中。',
      'Your proof is approved.': '您的证明已通过审核。',
      'Field cannot be empty.': '此字段不能为空。',
      'File cannot be empty.': '文件不能为空。',
      'Please upload only jpeg, png or pdf file.':
        '请仅上传 jpeg、png 或 pdf 文件。',
      'File cannot be larger than 4 megabytes.': '文件大小不能超过 4 兆字节。',
      'Failed to submit proof of status.': '提交身份证明失败。',
      'Your educational status has not been confirmed.':
        '您的教育身份尚未得到确认。',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        '如果您想再次申请并解锁教育优惠，请发送电子邮件至 education@chaos.com。',
      'You already have an active EDU subscription for this product.':
        '您已拥有此产品的有效 EDU 订阅。',
      'Thank you for your order': '感谢您的订购',
      'Go create something awesome!': '去创作精彩作品吧！',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        '您的产品已可供下载。我们将向您发送一封包含所有必要说明的电子邮件。',
      Download: '下载',
      'Go to admin dashboard': '前往管理控制台',
      Mail: '邮件',
      Contact: '联系',
      email: '电子邮件',
      'Continue with payment details': '继续填写支付详情',
      'switch user': '切换用户',
      edit: '编辑',
      'Order summary': '订单摘要',
      'Always included': '始终包含',
      'You already have an active or expired license.':
        '您已拥有有效或已过期的许可证。',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        '您已拥有此产品的有效或已过期许可证。请在您的账户中<link>管理或升级</link>您的订阅。',
      'Referral limit exceeded.': '已超出推荐上限。',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        '通过推荐计划，您最多可购买 3 个许可证。请减少购物车中的许可证数量，开始您的设计吧！',
      'Start free trial': '开始免费试用',
      '{{name}} {{days}}-day free trial ends':
        '{{name}} 的 {{days}} 天免费试用将结束',
      'Due {{date}}': '到期：{{date}}',
      '+ taxes': '+ 税费',
      'Pay Now': '立即支付',
      'Free trial terms': '免费试用条款',
      'Billing starts automatically after the free trial ends.':
        '免费试用结束后将自动开始计费。',
      'Cancel before {{date}} to avoid getting billed.':
        '请在 {{date}} 之前取消，以免产生费用。',
      'Your free trial version is ready': '您的免费试用版已准备就绪',
      'Millions of users trust our products': '数百万用户信赖我们的产品',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}}，基于 {{reviews}} 条评价',
      'Free learning resources, support & community access':
        '免费学习资源、支持及社区访问权限',
      'Limited time introductory prices': '限时特惠价格',
      'Purchase Limit Reached': '已达到购买上限',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        '超过 {{currencySymbol}}{{limit}} 的购买无法在线完成。',
      'Please contact our Sales team to proceed with your order.':
        '请联系我们的销售团队以继续处理您的订单。',
      Close: '关闭',
      'Credit/Debit card': '信用卡/借记卡',
      'Pay {{currencySymbol}}{{amount}}': '支付 {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': '使用 PayPal 结账',
      '{{licenseType}}, billed {{cadence}}': '{{licenseType}}，{{cadence}}计费',
      'Product Overview': '产品概览',
      'Your cart is empty': '您的购物车是空的',
      'Get your products now and start creating something awesome.':
        '立即获取您的产品，开始创作精彩作品。',
      'Explore our products': '探索我们的产品',
      'Upgrade for only € 5': '仅需 € 5 即可升级',
      'Upgrade now': '立即升级',
      Includes: '包含',
      'Your selection': '您的选择',
      'Continue with checkout': '继续结账',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        '数量：{{quantity}} | {{licenseType}}，{{cadence}}计费',
      Total: '总计',
      'Increase quantity': '增加数量',
      'Decrease quantity': '减少数量',
      'Go to pricing': '前往价格页面',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        '此订单目前无法处理。如需帮助，请联系 Chaos License Compliance Team。',
      'Managed users are not allowed to buy products.':
        '受管理用户不可购买产品。',
      'Your account is cancelled.': '您的账户已取消。',
      'Please contact the Chaos License Compliance Team for assistance.':
        '如需帮助，请联系 Chaos License Compliance Team。',
      'PayPal init failed.': 'PayPal 初始化失败。',
      'PayPal payment failed.': 'PayPal 支付失败。',
      'Placing order failed.': '下单失败。',
      'Payment failed.': '支付失败。',
      'Promo code': '促销代码',
      'Remove promo code': '移除促销代码',
      Apply: '应用',
      'Promo code applied.': '促销代码已应用。',
      'We accept': '我们接受',
      'Amnesty discount applied.': '已应用特赦折扣。',
      'Code not valid or already used.': '代码无效或已被使用。',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        '如需解决您的案件，请通过 licensecompliance@chaos.com 与我们联系。',
      'Promo Applied.': '促销已应用。',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '本订单中每件符合条件的产品均包含 3,000 个免费 Chaos Credits！您的全部积分将在结账完成后发放到您的账户。',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        '本订单包含 500 个免费 Chaos Credits！积分将在结账完成后一次性发放。',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} 个许可证 - {{cadence}}计费',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} 个许可证 - {{cadence}}计费',
      '{{count}} license - billed {{cadence}}':
        '{{count}} 个许可证 - {{cadence}}计费',
      monthly: '每月',
      annually: '每年',
      'every 3 years': '每 3 年',
      named: '指定',
      floating: '浮动',
    },
  },
  kr: {
    translation: {
      'Failed to load the payment form.': '결제 양식을 불러오지 못했습니다.',
      'Oops... something went wrong': '이런... 문제가 발생했습니다',
      'Please refresh the page to try again.':
        '페이지를 새로고침한 후 다시 시도해 주세요.',
      'First name': '이름',
      'Last name': '성',
      Address: '주소',
      City: '도시',
      'Zip code': '우편번호',
      'Country or region': '국가 혹은 지역',
      Optional: '선택',
      Company: '회사',
      'Payment method': '지불 방법',
      Subtotal: '소계',
      Taxes: '세금',
      Remove: '제거하기',
      Quantity: '수량',
      'Continue shopping': '구매 계속하기',
      'Please enter a valid email address.':
        '유효한 이메일 주소를 입력해 주세요.',
      'Please enter a valid promo code.':
        '유효한 프로모션 코드를 입력해 주세요.',
      'Billing information': '청구 정보',
      '14-day money back guarantee.': '14일 환불 보장.',
      'Please select': '선택해 주세요',
      'VAT ID': 'VAT ID',
      'Payment Details': '결제 세부 정보',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        '이 제품을 구매하면 <privacy>데이터 개인정보 보호</privacy>, <terms>이용약관</terms> 및 <eula>EULA</eula>에 동의하는 것으로 간주됩니다.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        '모든 Chaos 제품은 전문가용으로만 제공되며 일반 소비자용이 아닙니다.',
      'Loading your cart…': '장바구니를 불러오는 중…',
      'Proof of student status': '학생 신분 증명',
      'Expected graduation date': '졸업 예정일',
      'Choose date': '날짜 선택',
      'Name of academic institution': '교육 기관 이름',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': '교육 기관 소재 도시',
      Oxford: 'Oxford',
      'Country of academic institution': '교육 기관 소재 국가',
      'Proof of student status document (jpg, png, pdf)':
        '학생 신분 증명 서류 (jpg, png, pdf)',
      'Choose file': '파일 선택',
      'How we review your documents': '서류 검토 방법',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        '학생 할인을 위해 제출된 서류 검토를 돕기 위해, 당사는 서류의 외관상 유효성에 대한 참고용 평가를 제공하여 팀을 지원하는 인공지능(AI) 시스템을 사용합니다. 최종 결정은 항상 사람 검토자가 내립니다. 문의 사항이 있거나 데이터 보호 권리를 행사하려면 당사의',
      '<policy>Privacy Policy</policy>.':
        '<policy>개인정보 처리방침</policy>을 확인해 주세요.',
      'Additional information (optional)': '추가 정보 (선택 사항)',
      'What is considered valid evidence of current enrollment?':
        '현재 재학 중임을 증명하는 유효한 자료로 무엇이 인정되나요?',
      'A valid, dated student ID which includes your name and photo':
        '이름과 사진이 포함된 유효하고 날짜가 기재된 학생증',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        '재학 상태, 이름, 교육 기관 및 재학 기간이 명시된 학술 서류. 예시로는 성적 증명서, 등록금 고지서, 현재 성적표 또는 학업 진도 보고서, 날짜가 기재된 현재 수업 시간표 등이 있습니다.',
      'You can find <eligibility>more details here.</eligibility>':
        '<eligibility>여기에서 자세한 내용을 확인할 수 있습니다.</eligibility>',
      'Your proof is under review.': '제출하신 증명이 검토 중입니다.',
      'Your proof is approved.': '제출하신 증명이 승인되었습니다.',
      'Field cannot be empty.': '필수 입력 항목입니다.',
      'File cannot be empty.': '파일을 선택해야 합니다.',
      'Please upload only jpeg, png or pdf file.':
        'jpeg, png 또는 pdf 파일만 업로드해 주세요.',
      'File cannot be larger than 4 megabytes.':
        '파일 크기는 4메가바이트를 초과할 수 없습니다.',
      'Failed to submit proof of status.': '신분 증명 제출에 실패했습니다.',
      'Your educational status has not been confirmed.':
        '교육 기관 소속이 확인되지 않았습니다.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        '다시 신청하여 교육 할인을 받으시려면 education@chaos.com 으로 이메일을 보내 주세요.',
      'You already have an active EDU subscription for this product.':
        '이 제품에 대한 활성 EDU 구독이 이미 있습니다.',
      'Thank you for your order': '주문해 주셔서 감사합니다',
      'Go create something awesome!': '멋진 작품을 만들어 보세요!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        '제품을 다운로드할 준비가 되었습니다. 필요한 모든 안내 사항을 이메일로 보내 드리겠습니다.',
      Download: '다운로드',
      'Go to admin dashboard': '관리자 대시보드로 이동',
      Mail: '메일',
      Contact: '문의',
      email: '이메일',
      'Continue with payment details': '결제 세부 정보로 계속하기',
      'switch user': '사용자 전환',
      edit: '편집',
      'Order summary': '주문 요약',
      'Always included': '항상 포함',
      'You already have an active or expired license.':
        '이미 활성화되었거나 만료된 라이선스가 있습니다.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        '이 제품에 대한 활성화되었거나 만료된 라이선스가 이미 있습니다. 계정에서 구독을 <link>관리하거나 업그레이드</link>하세요.',
      'Referral limit exceeded.': '추천 한도를 초과했습니다.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        '추천 프로그램을 통해 최대 3개의 라이선스를 구매할 수 있습니다. 장바구니의 라이선스 수량을 줄이고 디자인을 시작하세요!',
      'Start free trial': '무료 체험 시작',
      '{{name}} {{days}}-day free trial ends':
        '{{name}} {{days}}일 무료 체험이 종료됩니다',
      'Due {{date}}': '만료일: {{date}}',
      '+ taxes': '+ 세금',
      'Pay Now': '지금 결제',
      'Free trial terms': '무료 체험 약관',
      'Billing starts automatically after the free trial ends.':
        '무료 체험이 종료되면 자동으로 청구가 시작됩니다.',
      'Cancel before {{date}} to avoid getting billed.':
        '청구를 피하려면 {{date}} 이전에 취소하세요.',
      'Your free trial version is ready': '무료 체험판이 준비되었습니다',
      'Millions of users trust our products':
        '수백만 명의 사용자가 당사 제품을 신뢰합니다',
      '{{rating}} based on {{reviews}} reviews':
        '리뷰 {{reviews}}건 기준 {{rating}}',
      'Free learning resources, support & community access':
        '무료 학습 리소스, 지원 및 커뮤니티 이용',
      'Limited time introductory prices': '기간 한정 출시 기념 가격',
      'Purchase Limit Reached': '구매 한도에 도달했습니다',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        '{{currencySymbol}}{{limit}}을 초과하는 구매는 온라인으로 완료할 수 없습니다.',
      'Please contact our Sales team to proceed with your order.':
        '주문을 진행하려면 영업팀에 문의해 주세요.',
      Close: '닫기',
      'Credit/Debit card': '신용/직불 카드',
      'Pay {{currencySymbol}}{{amount}}': '{{currencySymbol}}{{amount}} 결제',
      'Checkout with PayPal': 'PayPal로 결제',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, {{cadence}} 청구',
      'Product Overview': '제품 개요',
      'Your cart is empty': '장바구니가 비어 있습니다',
      'Get your products now and start creating something awesome.':
        '지금 제품을 받아 멋진 작품을 만들어 보세요.',
      'Explore our products': '제품 둘러보기',
      'Upgrade for only € 5': '단 € 5로 업그레이드',
      'Upgrade now': '지금 업그레이드',
      Includes: '포함 사항',
      'Your selection': '선택 항목',
      'Continue with checkout': '결제 계속하기',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        '수량: {{quantity}} | {{licenseType}}, {{cadence}} 청구',
      Total: '총액',
      'Increase quantity': '수량 늘리기',
      'Decrease quantity': '수량 줄이기',
      'Go to pricing': '가격 페이지로 이동',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        '현재 이 주문을 처리할 수 없습니다. 도움이 필요하시면 Chaos License Compliance Team에 문의해 주세요.',
      'Managed users are not allowed to buy products.':
        '관리 대상 사용자는 제품을 구매할 수 없습니다.',
      'Your account is cancelled.': '계정이 해지되었습니다.',
      'Please contact the Chaos License Compliance Team for assistance.':
        '도움이 필요하시면 Chaos License Compliance Team에 문의해 주세요.',
      'PayPal init failed.': 'PayPal 초기화에 실패했습니다.',
      'PayPal payment failed.': 'PayPal 결제에 실패했습니다.',
      'Placing order failed.': '주문을 접수하지 못했습니다.',
      'Payment failed.': '결제에 실패했습니다.',
      'Promo code': '프로모션 코드',
      'Remove promo code': '프로모션 코드 제거',
      Apply: '적용',
      'Promo code applied.': '프로모션 코드가 적용되었습니다.',
      'We accept': '사용 가능한 결제 수단',
      'Amnesty discount applied.': '사면 할인이 적용되었습니다.',
      'Code not valid or already used.':
        '코드가 유효하지 않거나 이미 사용되었습니다.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        '사건을 해결하려면 licensecompliance@chaos.com 으로 문의해 주세요.',
      'Promo Applied.': '프로모션이 적용되었습니다.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '이 주문의 적용 대상 제품마다 3,000 무료 Chaos Credits가 포함됩니다! 총 크레딧은 결제 완료 시 계정에 지급됩니다.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        '이 주문에는 500 무료 Chaos Credits가 포함됩니다! 크레딧은 결제 완료 시 한 번 지급됩니다.',
      '{{count}} license - billed {{cadence}}_one':
        '라이선스 {{count}}개 - {{cadence}} 청구',
      '{{count}} license - billed {{cadence}}_other':
        '라이선스 {{count}}개 - {{cadence}} 청구',
      '{{count}} license - billed {{cadence}}':
        '라이선스 {{count}}개 - {{cadence}} 청구',
      monthly: '매월',
      annually: '매년',
      'every 3 years': '3년마다',
      named: '지정',
      floating: '플로팅',
    },
  },
  it: {
    translation: {
      'Failed to load the payment form.':
        'Impossibile caricare il modulo di pagamento.',
      'Oops... something went wrong': 'Ops... qualcosa è andato storto',
      'Please refresh the page to try again.':
        'Aggiorna la pagina per riprovare.',
      'First name': 'Nome',
      'Last name': 'Cognome',
      Address: 'Indirizzo',
      City: 'Città',
      'Zip code': 'Codice postale',
      'Country or region': 'Paese / Regione',
      Optional: 'Opzionale',
      Company: 'Azienda',
      'Payment method': 'Metodo di pagamento',
      Subtotal: 'Subtotale',
      Taxes: 'Imposte',
      Remove: 'Rimuovi',
      Quantity: 'Quantità',
      'Continue shopping': 'Continua a fare acquisti',
      'Please enter a valid email address.':
        'Inserisci un indirizzo email valido.',
      'Please enter a valid promo code.':
        'Inserisci un codice promozionale valido.',
      'Billing information': 'Dati di fatturazione',
      '14-day money back guarantee.': 'Rimborso garantito per 14 giorni.',
      'Please select': 'Seleziona',
      'VAT ID': 'Partita IVA',
      'Payment Details': 'Dettagli del pagamento',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        "Acquistando questo prodotto, confermi di accettare la <privacy>privacy dei dati</privacy>, i <terms>termini e condizioni</terms> e l'<eula>EULA</eula>.",
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Tutti i prodotti Chaos sono destinati esclusivamente a un uso professionale e non al consumo privato.',
      'Loading your cart…': 'Caricamento del carrello…',
      'Proof of student status': 'Prova dello status di studente',
      'Expected graduation date': 'Data prevista di conseguimento del titolo',
      'Choose date': 'Scegli la data',
      'Name of academic institution': "Nome dell'istituto accademico",
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': "Città dell'istituto accademico",
      Oxford: 'Oxford',
      'Country of academic institution': "Paese dell'istituto accademico",
      'Proof of student status document (jpg, png, pdf)':
        'Documento di prova dello status di studente (jpg, png, pdf)',
      'Choose file': 'Scegli il file',
      'How we review your documents': 'Come esaminiamo i tuoi documenti',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        "Per aiutare a esaminare i documenti inviati per gli sconti studenti, utilizziamo un sistema di intelligenza artificiale (IA) che assiste il nostro team fornendo una valutazione indicativa dell'apparente validità di un documento. Le decisioni finali vengono sempre prese da un revisore umano. Puoi contattarci per domande o per esercitare i tuoi diritti di protezione dei dati consultando la nostra",
      '<policy>Privacy Policy</policy>.':
        '<policy>Informativa sulla privacy</policy>.',
      'Additional information (optional)':
        'Informazioni aggiuntive (facoltativo)',
      'What is considered valid evidence of current enrollment?':
        "Che cosa è considerato una prova valida dell'iscrizione in corso?",
      'A valid, dated student ID which includes your name and photo':
        'Un tesserino studentesco valido e datato che includa il tuo nome e la tua foto',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        "Un documento accademico che attesti il tuo stato di iscrizione, il tuo nome, l'istituto scolastico e le date di iscrizione. Alcuni esempi sono un certificato degli esami, una ricevuta delle tasse universitarie, una pagella o un rapporto sui progressi attuale, un orario delle lezioni attuale e datato, ecc.",
      'You can find <eligibility>more details here.</eligibility>':
        'Puoi trovare <eligibility>maggiori dettagli qui.</eligibility>',
      'Your proof is under review.': 'La tua prova è in fase di revisione.',
      'Your proof is approved.': 'La tua prova è stata approvata.',
      'Field cannot be empty.': 'Il campo non può essere vuoto.',
      'File cannot be empty.': 'Il file non può essere vuoto.',
      'Please upload only jpeg, png or pdf file.':
        'Carica solo file jpeg, png o pdf.',
      'File cannot be larger than 4 megabytes.':
        'Il file non può superare i 4 megabyte.',
      'Failed to submit proof of status.':
        'Invio della prova dello status non riuscito.',
      'Your educational status has not been confirmed.':
        'Il tuo status di studente non è stato confermato.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        "Se desideri presentare nuovamente la richiesta e sbloccare lo sconto per studenti, scrivici all'indirizzo education@chaos.com.",
      'You already have an active EDU subscription for this product.':
        'Hai già un abbonamento EDU attivo per questo prodotto.',
      'Thank you for your order': 'Grazie per il tuo ordine',
      'Go create something awesome!': 'Vai a creare qualcosa di straordinario!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        "I tuoi prodotti sono pronti per il download. Ti invieremo un'email con tutte le istruzioni necessarie.",
      Download: 'Scarica',
      'Go to admin dashboard': 'Vai alla dashboard di amministrazione',
      Mail: 'E-mail',
      Contact: 'Contatto',
      email: 'email',
      'Continue with payment details': 'Continua con i dettagli del pagamento',
      'switch user': 'cambia utente',
      edit: 'modifica',
      'Order summary': "Riepilogo dell'ordine",
      'Always included': 'Sempre incluso',
      'You already have an active or expired license.':
        'Hai già una licenza attiva o scaduta.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        "Hai già una licenza attiva o scaduta per questo prodotto. <link>Gestisci o esegui l'upgrade</link> del tuo abbonamento dal tuo account.",
      'Referral limit exceeded.': 'Limite di referral superato.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'Puoi acquistare fino a 3 licenze tramite il programma di referral. Riduci il numero di licenze nel carrello e inizia a progettare!',
      'Start free trial': 'Inizia la prova gratuita',
      '{{name}} {{days}}-day free trial ends':
        'La prova gratuita di {{days}} giorni di {{name}} termina',
      'Due {{date}}': 'Scade il {{date}}',
      '+ taxes': '+ imposte',
      'Pay Now': 'Paga ora',
      'Free trial terms': 'Termini della prova gratuita',
      'Billing starts automatically after the free trial ends.':
        'La fatturazione inizia automaticamente al termine della prova gratuita.',
      'Cancel before {{date}} to avoid getting billed.':
        "Annulla prima del {{date}} per evitare l'addebito.",
      'Your free trial version is ready':
        'La tua versione di prova gratuita è pronta',
      'Millions of users trust our products':
        'Milioni di utenti si affidano ai nostri prodotti',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} sulla base di {{reviews}} recensioni',
      'Free learning resources, support & community access':
        'Risorse di apprendimento gratuite, supporto e accesso alla community',
      'Limited time introductory prices':
        'Prezzi di lancio per un periodo limitato',
      'Purchase Limit Reached': 'Limite di acquisto raggiunto',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Gli acquisti superiori a {{currencySymbol}}{{limit}} non possono essere completati online.',
      'Please contact our Sales team to proceed with your order.':
        "Contatta il nostro team di vendita per procedere con l'ordine.",
      Close: 'Chiudi',
      'Credit/Debit card': 'Carta di credito/debito',
      'Pay {{currencySymbol}}{{amount}}': 'Paga {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': 'Paga con PayPal',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, fatturazione {{cadence}}',
      'Product Overview': 'Panoramica del prodotto',
      'Your cart is empty': 'Il tuo carrello è vuoto',
      'Get your products now and start creating something awesome.':
        'Ottieni subito i tuoi prodotti e inizia a creare qualcosa di straordinario.',
      'Explore our products': 'Esplora i nostri prodotti',
      'Upgrade for only € 5': "Esegui l'upgrade per soli € 5",
      'Upgrade now': "Esegui l'upgrade ora",
      Includes: 'Include',
      'Your selection': 'La tua selezione',
      'Continue with checkout': 'Procedi al pagamento',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Quantità: {{quantity}} | {{licenseType}}, fatturazione {{cadence}}',
      Total: 'Totale',
      'Increase quantity': 'Aumenta la quantità',
      'Decrease quantity': 'Diminuisci la quantità',
      'Go to pricing': 'Vai ai prezzi',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'Al momento non è possibile elaborare questo ordine. Per assistenza, contatta il Chaos License Compliance Team.',
      'Managed users are not allowed to buy products.':
        'Gli utenti gestiti non possono acquistare prodotti.',
      'Your account is cancelled.': 'Il tuo account è stato annullato.',
      'Please contact the Chaos License Compliance Team for assistance.':
        'Per assistenza, contatta il Chaos License Compliance Team.',
      'PayPal init failed.': 'Inizializzazione di PayPal non riuscita.',
      'PayPal payment failed.': 'Pagamento con PayPal non riuscito.',
      'Placing order failed.': "Invio dell'ordine non riuscito.",
      'Payment failed.': 'Pagamento non riuscito.',
      'Promo code': 'Codice promozionale',
      'Remove promo code': 'Rimuovi codice promozionale',
      Apply: 'Applica',
      'Promo code applied.': 'Codice promozionale applicato.',
      'We accept': 'Accettiamo',
      'Amnesty discount applied.': 'Sconto amnistia applicato.',
      'Code not valid or already used.': 'Codice non valido o già utilizzato.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        "Contattaci all'indirizzo licensecompliance@chaos.com per risolvere il tuo caso.",
      'Promo Applied.': 'Promozione applicata.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '3.000 Chaos Credits gratuiti sono inclusi con ogni prodotto idoneo di questo ordine! Il totale dei crediti verrà assegnato al tuo account al completamento del checkout.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        'Questo ordine include 500 Chaos Credits gratuiti! I crediti verranno assegnati una sola volta al completamento del checkout.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} licenza - fatturazione {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} licenze - fatturazione {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} licenze - fatturazione {{cadence}}',
      monthly: 'mensile',
      annually: 'annuale',
      'every 3 years': 'ogni 3 anni',
      named: 'nominativa',
      floating: 'fluttuante',
    },
  },
  de: {
    translation: {
      'Failed to load the payment form.':
        'Das Zahlungsformular konnte nicht geladen werden.',
      'Oops... something went wrong': 'Hoppla... etwas ist schiefgelaufen',
      'Please refresh the page to try again.':
        'Bitte aktualisiere die Seite, um es erneut zu versuchen.',
      'First name': 'Vorname',
      'Last name': 'Nachname',
      Address: 'Adresse',
      City: 'Stadt',
      'Zip code': 'Postleitzahl',
      'Country or region': 'Land / Region',
      Optional: 'Optional',
      Company: 'Unternehmen',
      'Payment method': 'Zahlungsmethode',
      Subtotal: 'Zwischensumme',
      Taxes: 'Steuern',
      Remove: 'Entfernen',
      Quantity: 'Menge',
      'Continue shopping': 'Einkauf fortsetzen',
      'Please enter a valid email address.':
        'Bitte gib eine gültige E-Mail-Adresse ein.',
      'Please enter a valid promo code.':
        'Bitte gib einen gültigen Promo-Code ein.',
      'Billing information': 'Rechnungsdaten',
      '14-day money back guarantee.': '14-tägige Geld-zurück-Garantie.',
      'Please select': 'Bitte auswählen',
      'VAT ID': 'USt-IdNr.',
      'Payment Details': 'Zahlungsdetails',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        'Mit dem Kauf dieses Produkts bestätigst du, dass du den <privacy>Datenschutz</privacy>, die <terms>Allgemeinen Geschäftsbedingungen</terms> und die <eula>EULA</eula> akzeptierst.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Alle Chaos-Produkte sind ausschließlich für den professionellen Einsatz und nicht für den Verbrauchergebrauch bestimmt.',
      'Loading your cart…': 'Dein Warenkorb wird geladen…',
      'Proof of student status': 'Nachweis des Studentenstatus',
      'Expected graduation date': 'Voraussichtliches Abschlussdatum',
      'Choose date': 'Datum auswählen',
      'Name of academic institution': 'Name der Bildungseinrichtung',
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': 'Stadt der Bildungseinrichtung',
      Oxford: 'Oxford',
      'Country of academic institution': 'Land der Bildungseinrichtung',
      'Proof of student status document (jpg, png, pdf)':
        'Nachweisdokument für den Studentenstatus (jpg, png, pdf)',
      'Choose file': 'Datei auswählen',
      'How we review your documents': 'Wie wir deine Dokumente prüfen',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        'Zur Unterstützung bei der Prüfung von Dokumenten, die für Studentenrabatte eingereicht werden, verwenden wir ein System der künstlichen Intelligenz (KI), das unser Team unterstützt, indem es eine orientierende Einschätzung der augenscheinlichen Gültigkeit eines Dokuments liefert. Die endgültige Entscheidung trifft immer ein menschlicher Prüfer. Bei Fragen oder zur Ausübung deiner Datenschutzrechte kannst du uns kontaktieren – siehe dazu unsere',
      '<policy>Privacy Policy</policy>.':
        '<policy>Datenschutzrichtlinie</policy>.',
      'Additional information (optional)':
        'Zusätzliche Informationen (optional)',
      'What is considered valid evidence of current enrollment?':
        'Was gilt als gültiger Nachweis der aktuellen Immatrikulation?',
      'A valid, dated student ID which includes your name and photo':
        'Ein gültiger, datierter Studentenausweis mit deinem Namen und Foto',
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        'Ein akademisches Dokument, das deinen Immatrikulationsstatus, deinen Namen, die Bildungseinrichtung und die Immatrikulationszeiträume angibt. Beispiele sind eine Notenübersicht, eine Studiengebührenrechnung, ein aktuelles Zeugnis oder ein Leistungsbericht, ein datierter aktueller Stundenplan usw.',
      'You can find <eligibility>more details here.</eligibility>':
        '<eligibility>Weitere Details findest du hier.</eligibility>',
      'Your proof is under review.': 'Dein Nachweis wird derzeit geprüft.',
      'Your proof is approved.': 'Dein Nachweis wurde genehmigt.',
      'Field cannot be empty.': 'Das Feld darf nicht leer sein.',
      'File cannot be empty.': 'Die Datei darf nicht leer sein.',
      'Please upload only jpeg, png or pdf file.':
        'Bitte lade nur jpeg-, png- oder pdf-Dateien hoch.',
      'File cannot be larger than 4 megabytes.':
        'Die Datei darf nicht größer als 4 Megabyte sein.',
      'Failed to submit proof of status.':
        'Der Statusnachweis konnte nicht übermittelt werden.',
      'Your educational status has not been confirmed.':
        'Dein Bildungsstatus wurde nicht bestätigt.',
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        'Wenn du dich erneut bewerben und den Bildungsrabatt freischalten möchtest, schreibe uns bitte eine E-Mail an education@chaos.com.',
      'You already have an active EDU subscription for this product.':
        'Du hast bereits ein aktives EDU-Abonnement für dieses Produkt.',
      'Thank you for your order': 'Vielen Dank für deine Bestellung',
      'Go create something awesome!': 'Erschaffe etwas Großartiges!',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        'Deine Produkte stehen zum Download bereit. Wir senden dir eine E-Mail mit allen erforderlichen Anweisungen.',
      Download: 'Herunterladen',
      'Go to admin dashboard': 'Zum Admin-Dashboard',
      Mail: 'E-Mail',
      Contact: 'Kontakt',
      email: 'E-Mail',
      'Continue with payment details': 'Mit den Zahlungsdetails fortfahren',
      'switch user': 'Benutzer wechseln',
      edit: 'bearbeiten',
      'Order summary': 'Bestellübersicht',
      'Always included': 'Immer enthalten',
      'You already have an active or expired license.':
        'Du hast bereits eine aktive oder abgelaufene Lizenz.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'Du hast bereits eine aktive oder abgelaufene Lizenz für dieses Produkt. Bitte <link>verwalte oder aktualisiere</link> dein Abonnement in deinem Konto.',
      'Referral limit exceeded.': 'Empfehlungslimit überschritten.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'Über das Empfehlungsprogramm kannst du bis zu 3 Lizenzen kaufen. Bitte reduziere die Anzahl der Lizenzen in deinem Warenkorb und leg mit dem Gestalten los!',
      'Start free trial': 'Kostenlose Testversion starten',
      '{{name}} {{days}}-day free trial ends':
        'Die {{days}}-tägige kostenlose Testversion von {{name}} endet',
      'Due {{date}}': 'Fällig am {{date}}',
      '+ taxes': '+ Steuern',
      'Pay Now': 'Jetzt bezahlen',
      'Free trial terms': 'Bedingungen der kostenlosen Testversion',
      'Billing starts automatically after the free trial ends.':
        'Die Abrechnung beginnt automatisch nach Ablauf der kostenlosen Testversion.',
      'Cancel before {{date}} to avoid getting billed.':
        'Kündige vor dem {{date}}, um eine Abrechnung zu vermeiden.',
      'Your free trial version is ready':
        'Deine kostenlose Testversion ist bereit',
      'Millions of users trust our products':
        'Millionen von Nutzern vertrauen unseren Produkten',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} basierend auf {{reviews}} Bewertungen',
      'Free learning resources, support & community access':
        'Kostenlose Lernressourcen, Support und Community-Zugang',
      'Limited time introductory prices':
        'Einführungspreise für begrenzte Zeit',
      'Purchase Limit Reached': 'Kauflimit erreicht',
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Käufe über {{currencySymbol}}{{limit}} können nicht online abgeschlossen werden.',
      'Please contact our Sales team to proceed with your order.':
        'Bitte wende dich an unser Vertriebsteam, um mit deiner Bestellung fortzufahren.',
      Close: 'Schließen',
      'Credit/Debit card': 'Kredit-/Debitkarte',
      'Pay {{currencySymbol}}{{amount}}':
        '{{currencySymbol}}{{amount}} bezahlen',
      'Checkout with PayPal': 'Mit PayPal bezahlen',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, Abrechnung {{cadence}}',
      'Product Overview': 'Produktübersicht',
      'Your cart is empty': 'Dein Warenkorb ist leer',
      'Get your products now and start creating something awesome.':
        'Hol dir jetzt deine Produkte und beginne, etwas Großartiges zu erschaffen.',
      'Explore our products': 'Entdecke unsere Produkte',
      'Upgrade for only € 5': 'Upgrade für nur € 5',
      'Upgrade now': 'Jetzt upgraden',
      Includes: 'Beinhaltet',
      'Your selection': 'Deine Auswahl',
      'Continue with checkout': 'Mit der Kasse fortfahren',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Menge: {{quantity}} | {{licenseType}}, Abrechnung {{cadence}}',
      Total: 'Gesamt',
      'Increase quantity': 'Menge erhöhen',
      'Decrease quantity': 'Menge verringern',
      'Go to pricing': 'Zu den Preisen',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        'Diese Bestellung kann derzeit nicht bearbeitet werden. Bitte wende dich an das Chaos License Compliance Team, um Unterstützung zu erhalten.',
      'Managed users are not allowed to buy products.':
        'Verwaltete Benutzer dürfen keine Produkte kaufen.',
      'Your account is cancelled.': 'Dein Konto ist gekündigt.',
      'Please contact the Chaos License Compliance Team for assistance.':
        'Bitte wende dich an das Chaos License Compliance Team, um Unterstützung zu erhalten.',
      'PayPal init failed.': 'PayPal-Initialisierung fehlgeschlagen.',
      'PayPal payment failed.': 'PayPal-Zahlung fehlgeschlagen.',
      'Placing order failed.': 'Die Bestellung ist fehlgeschlagen.',
      'Payment failed.': 'Zahlung fehlgeschlagen.',
      'Promo code': 'Promo-Code',
      'Remove promo code': 'Promo-Code entfernen',
      Apply: 'Anwenden',
      'Promo code applied.': 'Promo-Code angewendet.',
      'We accept': 'Wir akzeptieren',
      'Amnesty discount applied.': 'Amnestie-Rabatt angewendet.',
      'Code not valid or already used.':
        'Code ungültig oder bereits verwendet.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        'Kontaktiere uns unter licensecompliance@chaos.com, um deinen Fall zu lösen.',
      'Promo Applied.': 'Promo angewendet.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '3.000 kostenlose Chaos Credits sind bei jedem berechtigten Produkt dieser Bestellung enthalten! Deine gesamten Credits werden deinem Konto nach Abschluss des Kaufvorgangs gutgeschrieben.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        'Diese Bestellung enthält 500 kostenlose Chaos Credits! Die Credits werden nach Abschluss des Checkouts einmalig gutgeschrieben.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} Lizenz - Abrechnung {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} Lizenzen - Abrechnung {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} Lizenzen - Abrechnung {{cadence}}',
      monthly: 'monatlich',
      annually: 'jährlich',
      'every 3 years': 'alle 3 Jahre',
      named: 'benannt',
      floating: 'Floating',
    },
  },
  fr: {
    translation: {
      'Failed to load the payment form.':
        'Échec du chargement du formulaire de paiement.',
      'Oops... something went wrong': "Oups... une erreur s'est produite",
      'Please refresh the page to try again.':
        'Veuillez actualiser la page pour réessayer.',
      'First name': 'Prénom',
      'Last name': 'Nom',
      Address: 'Adresse',
      City: 'Ville',
      'Zip code': 'Code postal',
      'Country or region': 'Pays / Région',
      Optional: 'Facultatif',
      Company: 'Entreprise',
      'Payment method': 'Mode de paiement',
      Subtotal: 'Sous-total',
      Taxes: 'Taxes',
      Remove: 'Supprimer',
      Quantity: 'Quantité',
      'Continue shopping': 'Continuez vos achats',
      'Please enter a valid email address.':
        'Veuillez saisir une adresse e-mail valide.',
      'Please enter a valid promo code.':
        'Veuillez saisir un code promo valide.',
      'Billing information': 'Informations de facturation',
      '14-day money back guarantee.': 'Garantie de remboursement de 14 jours.',
      'Please select': 'Veuillez sélectionner',
      'VAT ID': 'Numéro de TVA',
      'Payment Details': 'Détails du paiement',
      'By buying this product, you confirm you accept the <privacy>Data privacy</privacy>, <terms>Terms & Conditions</terms>, and the <eula>EULA</eula>.':
        'En achetant ce produit, vous confirmez accepter la <privacy>confidentialité des données</privacy>, les <terms>conditions générales</terms> et le <eula>EULA</eula>.',
      'All Chaos products are intended for professional use only and not for consumer use.':
        'Tous les produits Chaos sont destinés à un usage professionnel uniquement et non à un usage par les consommateurs.',
      'Loading your cart…': 'Chargement de votre panier…',
      'Proof of student status': 'Justificatif de statut étudiant',
      'Expected graduation date': "Date de fin d'études prévue",
      'Choose date': 'Choisir une date',
      'Name of academic institution': "Nom de l'établissement d'enseignement",
      'Oxford Brookes University': 'Oxford Brookes University',
      'City of academic institution': "Ville de l'établissement d'enseignement",
      Oxford: 'Oxford',
      'Country of academic institution':
        "Pays de l'établissement d'enseignement",
      'Proof of student status document (jpg, png, pdf)':
        'Document justificatif de statut étudiant (jpg, png, pdf)',
      'Choose file': 'Choisir un fichier',
      'How we review your documents': 'Comment nous examinons vos documents',
      'To help review documents submitted for student discounts, we use an artificial intelligence (AI) system that assists our team by providing an indicative assessment of a document’s apparent validity. Final decisions are always made by a human reviewer. You may contact us with questions or to exercise your data protection rights by reviewing our':
        "Pour nous aider à examiner les documents soumis dans le cadre des réductions étudiantes, nous utilisons un système d'intelligence artificielle (IA) qui assiste notre équipe en fournissant une évaluation indicative de la validité apparente d'un document. Les décisions finales sont toujours prises par un examinateur humain. Vous pouvez nous contacter pour toute question ou pour exercer vos droits en matière de protection des données en consultant notre",
      '<policy>Privacy Policy</policy>.':
        '<policy>Politique de confidentialité</policy>.',
      'Additional information (optional)':
        'Informations complémentaires (facultatif)',
      'What is considered valid evidence of current enrollment?':
        "Qu'est-ce qui est considéré comme une preuve valable d'inscription en cours ?",
      'A valid, dated student ID which includes your name and photo':
        "Une carte d'étudiant valide et datée comportant votre nom et votre photo",
      'An academic document which states your enrolment status, your name, educational institution and dates of enrolment. Examples include a transcript of records, tuition bill, current student report card or progress report, dated current class schedule, etc.':
        "Un document académique indiquant votre statut d'inscription, votre nom, l'établissement d'enseignement et les dates d'inscription. Les exemples incluent un relevé de notes, une facture de frais de scolarité, un bulletin scolaire ou un rapport de progression actuel, un emploi du temps actuel daté, etc.",
      'You can find <eligibility>more details here.</eligibility>':
        'Vous trouverez <eligibility>plus de détails ici.</eligibility>',
      'Your proof is under review.':
        "Votre justificatif est en cours d'examen.",
      'Your proof is approved.': 'Votre justificatif a été approuvé.',
      'Field cannot be empty.': 'Le champ ne peut pas être vide.',
      'File cannot be empty.': 'Le fichier ne peut pas être vide.',
      'Please upload only jpeg, png or pdf file.':
        'Veuillez téléverser uniquement un fichier jpeg, png ou pdf.',
      'File cannot be larger than 4 megabytes.':
        'Le fichier ne peut pas dépasser 4 mégaoctets.',
      'Failed to submit proof of status.':
        "Échec de l'envoi du justificatif de statut.",
      'Your educational status has not been confirmed.':
        "Votre statut étudiant n'a pas été confirmé.",
      'Please email us at education@chaos.com if you would like to apply again and unlock the educational discount.':
        'Si vous souhaitez présenter une nouvelle demande et débloquer la réduction éducative, envoyez-nous un e-mail à education@chaos.com.',
      'You already have an active EDU subscription for this product.':
        'Vous avez déjà un abonnement EDU actif pour ce produit.',
      'Thank you for your order': 'Merci pour votre commande',
      'Go create something awesome!': 'Allez créer quelque chose de génial !',
      'Your products are ready for download. We will send you an email with all the necessary instructions.':
        'Vos produits sont prêts à être téléchargés. Nous vous enverrons un e-mail avec toutes les instructions nécessaires.',
      Download: 'Télécharger',
      'Go to admin dashboard': "Accéder au tableau de bord d'administration",
      Mail: 'E-mail',
      Contact: 'Contact',
      email: 'e-mail',
      'Continue with payment details': 'Continuer avec les détails du paiement',
      'switch user': "changer d'utilisateur",
      edit: 'modifier',
      'Order summary': 'Récapitulatif de la commande',
      'Always included': 'Toujours inclus',
      'You already have an active or expired license.':
        'Vous avez déjà une licence active ou expirée.',
      'You already have an active or expired license for this product. Please <link>manage or upgrade</link> your subscription from your account.':
        'Vous avez déjà une licence active ou expirée pour ce produit. Veuillez <link>gérer ou mettre à niveau</link> votre abonnement depuis votre compte.',
      'Referral limit exceeded.': 'Limite de parrainage dépassée.',
      'You can purchase up to 3 licenses via the referral program. Please reduce the amount of licenses in your cart and start designing!':
        'Vous pouvez acheter jusqu’à 3 licences via le programme de parrainage. Réduisez le nombre de licences dans votre panier et commencez à créer !',
      'Start free trial': "Démarrer l'essai gratuit",
      '{{name}} {{days}}-day free trial ends':
        "L'essai gratuit de {{days}} jours de {{name}} se termine",
      'Due {{date}}': 'Échéance le {{date}}',
      '+ taxes': '+ taxes',
      'Pay Now': 'Payer maintenant',
      'Free trial terms': "Conditions de l'essai gratuit",
      'Billing starts automatically after the free trial ends.':
        "La facturation commence automatiquement à la fin de l'essai gratuit.",
      'Cancel before {{date}} to avoid getting billed.':
        "Annulez avant le {{date}} pour éviter d'être facturé.",
      'Your free trial version is ready':
        "Votre version d'essai gratuite est prête",
      'Millions of users trust our products':
        'Des millions d’utilisateurs font confiance à nos produits',
      '{{rating}} based on {{reviews}} reviews':
        '{{rating}} sur la base de {{reviews}} avis',
      'Free learning resources, support & community access':
        "Ressources d'apprentissage gratuites, assistance et accès à la communauté",
      'Limited time introductory prices':
        'Prix de lancement pour une durée limitée',
      'Purchase Limit Reached': "Limite d'achat atteinte",
      'Purchases over {{currencySymbol}}{{limit}} cannot be completed online.':
        'Les achats supérieurs à {{currencySymbol}}{{limit}} ne peuvent pas être effectués en ligne.',
      'Please contact our Sales team to proceed with your order.':
        'Veuillez contacter notre équipe commerciale pour poursuivre votre commande.',
      Close: 'Fermer',
      'Credit/Debit card': 'Carte de crédit/débit',
      'Pay {{currencySymbol}}{{amount}}': 'Payer {{currencySymbol}}{{amount}}',
      'Checkout with PayPal': 'Payer avec PayPal',
      '{{licenseType}}, billed {{cadence}}':
        '{{licenseType}}, facturation {{cadence}}',
      'Product Overview': 'Aperçu du produit',
      'Your cart is empty': 'Votre panier est vide',
      'Get your products now and start creating something awesome.':
        'Obtenez vos produits dès maintenant et commencez à créer quelque chose de génial.',
      'Explore our products': 'Découvrez nos produits',
      'Upgrade for only € 5':
        'Passez à la version supérieure pour seulement € 5',
      'Upgrade now': 'Mettre à niveau maintenant',
      Includes: 'Comprend',
      'Your selection': 'Votre sélection',
      'Continue with checkout': 'Continuer vers le paiement',
      'Quantity: {{quantity}} | {{licenseType}}, billed {{cadence}}':
        'Quantité : {{quantity}} | {{licenseType}}, facturation {{cadence}}',
      Total: 'Total',
      'Increase quantity': 'Augmenter la quantité',
      'Decrease quantity': 'Diminuer la quantité',
      'Go to pricing': 'Accéder aux tarifs',
      'This order cannot be processed at this time. Please contact the Chaos License Compliance Team for assistance.':
        "Cette commande ne peut pas être traitée pour le moment. Veuillez contacter le Chaos License Compliance Team pour obtenir de l'aide.",
      'Managed users are not allowed to buy products.':
        'Les utilisateurs gérés ne sont pas autorisés à acheter des produits.',
      'Your account is cancelled.': 'Votre compte est résilié.',
      'Please contact the Chaos License Compliance Team for assistance.':
        "Veuillez contacter le Chaos License Compliance Team pour obtenir de l'aide.",
      'PayPal init failed.': "Échec de l'initialisation de PayPal.",
      'PayPal payment failed.': 'Échec du paiement PayPal.',
      'Placing order failed.': 'Échec de la validation de la commande.',
      'Payment failed.': 'Échec du paiement.',
      'Promo code': 'Code promo',
      'Remove promo code': 'Supprimer le code promo',
      Apply: 'Appliquer',
      'Promo code applied.': 'Code promo appliqué.',
      'We accept': 'Nous acceptons',
      'Amnesty discount applied.': "Remise d'amnistie appliquée.",
      'Code not valid or already used.': 'Code non valide ou déjà utilisé.',
      'Contact us at licensecompliance@chaos.com to resolve your case.':
        "Contactez-nous à l'adresse licensecompliance@chaos.com pour résoudre votre dossier.",
      'Promo Applied.': 'Promo appliquée.',
      '3,000 free Chaos Credits are included with each eligible product on this order! Your total credits will be provisioned to your account upon completion of checkout.':
        '3 000 Chaos Credits gratuits sont inclus avec chaque produit éligible de cette commande ! Le total de vos crédits sera attribué à votre compte à la fin du paiement.',
      '500 free Chaos Credits are included with this order! Credits will be provisioned once upon checkout completion.':
        'Cette commande comprend 500 Chaos Credits gratuits ! Les crédits seront attribués une seule fois à la finalisation de la commande.',
      '{{count}} license - billed {{cadence}}_one':
        '{{count}} licence - facturation {{cadence}}',
      '{{count}} license - billed {{cadence}}_other':
        '{{count}} licences - facturation {{cadence}}',
      '{{count}} license - billed {{cadence}}':
        '{{count}} licences - facturation {{cadence}}',
      monthly: 'mensuelle',
      annually: 'annuelle',
      'every 3 years': 'tous les 3 ans',
      named: 'nominative',
      floating: 'flottante',
    },
  },
};
